import React from 'react';
import gettext from '@eb/gettext';
import { ANCHOR_LINK, ROUTER_LINK, DIVIDER } from '@eb/eds-nav-list-item';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import { constants } from '@eb/event-create-publish-utils';
import { joinPath } from '@eb/path-utils';

import { VerticalDotsChunky } from '@eb/eds-iconography';

const DEFAULT_HELP_CENTER_LOCALE = 'en_US';
const {
    COYOTE_HELP_URLS,
    COYOTE_HELP_CENTER_URL_MAP,
    COYOTE_EVENT_HELP,
    ORG_ICON_COLOR,
    ACTION_HELP_ARTICLE,
    LABEL_HELP_CENTER,
    GA_TRACKING_EVENT_CATEGORY,
} = constants;

export const getLocalizedHelpCenterLink = (locale) => {
    let helpCenterLink = COYOTE_HELP_CENTER_URL_MAP[DEFAULT_HELP_CENTER_LOCALE];

    if (COYOTE_HELP_CENTER_URL_MAP[locale]) {
        helpCenterLink = COYOTE_HELP_CENTER_URL_MAP[locale];
    }

    return helpCenterLink;
};

export const getHelpCenterNavItem = (locale) => ({
    type: ANCHOR_LINK,
    path: getLocalizedHelpCenterLink(locale),
    content: gettext('Help Center'),
    target: '_blank',
    rel: 'noopener noreferrer',

    onClick: () =>
        trackAnalyticsEvent({
            action: ACTION_HELP_ARTICLE,
            label: LABEL_HELP_CENTER,
            category: GA_TRACKING_EVENT_CATEGORY,
        }),
});

export const getCoyoteHelpMenu = (supportUrl, locale) => {
    const helpMenuItems = COYOTE_HELP_URLS.map(
        ({ path, content, gaLabel }) => ({
            type: ANCHOR_LINK,
            path,
            content,
            target: '_blank',
            rel: 'noopener noreferrer',

            onClick: () =>
                trackAnalyticsEvent({
                    action: ACTION_HELP_ARTICLE,
                    label: gaLabel,
                    category: GA_TRACKING_EVENT_CATEGORY,
                }),
        }),
    );
    const helpCenterNavItem = getHelpCenterNavItem(locale);
    const navItems = [
        ...helpMenuItems,
        {
            type: DIVIDER,
        },
        helpCenterNavItem,
    ];

    return {
        label: gettext('Help'),
        fallbackUrl: supportUrl,
        navItems,
    };
};

export const getOverflowMenu = (urls, options) => {
    const { home } = urls;
    const {
        eventId,
        isManagePage,
        showCopy,
        showCancel,
        showDelete,
        onCancelClick,
        onDeleteClick,
        locale,
    } = options;
    const helpCenterNavItem = getHelpCenterNavItem(locale);
    const navItems = [];

    if (showCopy) {
        navItems.push({
            type: ANCHOR_LINK,
            path: `/myevent/${eventId}/copy/`,
            content: gettext('Copy Event'),
        });
    }

    if (showCancel) {
        navItems.push({
            type: ANCHOR_LINK,
            content: gettext('Cancel Event'),

            onClick: (e) => {
                e.preventDefault();
                onCancelClick();
            },
        });
    }

    if (showDelete) {
        navItems.push({
            type: ANCHOR_LINK,
            content: gettext('Delete Event'),

            onClick: (e) => {
                e.preventDefault();
                onDeleteClick();
            },
        });
    }

    navItems.push({ type: DIVIDER });
    navItems.push({
        type: ANCHOR_LINK,
        path: COYOTE_EVENT_HELP.path,
        content: COYOTE_EVENT_HELP.content,
        target: '_blank',
        rel: 'noopener noreferrer',

        onClick: () =>
            trackAnalyticsEvent({
                action: ACTION_HELP_ARTICLE,
                label: COYOTE_EVENT_HELP.gaLabel,
                category: GA_TRACKING_EVENT_CATEGORY,
            }),
    });
    navItems.push(helpCenterNavItem);

    return {
        label: gettext('More'),
        narrowIconType: <VerticalDotsChunky />,
        narrowIconColor: ORG_ICON_COLOR,
        hideDropIconWhenNarrow: true,
        fallbackUrl: home,
        navItems,
    };
};
